import { triggerEvent } from '@fec/assets/js/utils/event';
import {
  COMMENTS_TRIGGER_EDIT_USER_PROFILE,
  COMMENTS_TRIGGER_LOGOUT,
} from '@default/webview/js/classes/SrfCommentsEvents';
import { useAppContext } from '@Comments/context/AppContext';

import './UserInfo.scss';

export const UserInfo = () => {
  const { user, env } = useAppContext();

  const handleLogout = () => {
    triggerEvent(COMMENTS_TRIGGER_LOGOUT);
  };

  const handleEditUserProfile = () => {
    triggerEvent(COMMENTS_TRIGGER_EDIT_USER_PROFILE);
  };

  if (!user.name || !user.token) {
    return null;
  }

  return (
    <div className="srf-comments-header__userinfo">
      Sie sind angemeldet als&nbsp;
      {env.loginProvider === 'srg-login' ? (
        <button
          type="button"
          className="srf-comments-comment__action"
          onClick={handleEditUserProfile}>
          {user.name}
        </button>
      ) : (
        <button
          type="button"
          className="srf-comments-comment__action"
          data-capturescreen="editProfile">
          {user.name}
        </button>
      )}
      <span className="srf-comments-header__userInfo__logoutLink">
        &nbsp;(
        <button
          type="button"
          className="srf-comments-comment__action"
          onClick={() => {
            handleLogout();
          }}>
          abmelden
        </button>
        )
      </span>
    </div>
  );
};
